import React, { useState } from "react";
import {
  StyleSheet,
  View,
  KeyboardAvoidingView,
  Text,
  Alert,
  TouchableOpacity,
  Linking,
} from "react-native";
import * as Yup from "yup";

import usersApi from "../api/users";
import authApi from "../api/auth";
import useAuth from "../auth/useAuth";
import useApi from "../hooks/useApi";
import Screen from "../components/Screen";
import colors from "../config/colors";
import {
  AppForm,
  AppFormField,
  SubmitButton,
  AppFormPicker as Picker,
  ErrorMessage,
} from "../components/forms";
import ActivityIndicator from "../components/ActivityIndicator";
import CommonHeader from "../components/CommonHeader";
import { ScrollView } from "react-native";
import CommonFooter from "../components/CommonFooter";
import AppText from "../components/AppText";
import { StdAlert } from "../components/CustomAlert";

const validationSchema = Yup.object().shape({
  user_name: Yup.string().required().label("Name"),
  email: Yup.string().required().label("Email"),
  user_city: Yup.string().required().label("City"),
  user_zip: Yup.string().required().label("Zip"),
  user_country: Yup.string().required().label("Country"),
  password: Yup.string().required().min(4).label("Password"),
  confirmPassword: Yup.string()
    .required()
    .label("Confirm password")
    .test("passwords-match", "Passwords must match.", function (value) {
      return this.parent.password === value;
    }),
});

function SignupScreen({ navigation, route }) {
  // const keyboardVerticalOffset = Platform.OS === 'ios' ? 10 : 0;
  // const userType = route.params;
  const registerApi = useApi(usersApi.register);
  const loginApi = useApi(authApi.login);
  const auth = useAuth();
  const [error, setError] = useState();
  const [terms, setTerms] = useState(false);

  const privacyAction = () => {
    const url = "https://bluecardvisa.com/privacy-policy";
    openLink(url);
  };

  const termsAction = () => {
    const url = "https://bluecardvisa.com/terms-of-use";
    openLink(url);
  };

  const websiteAction = () => {
    const url = "https://bluecardvisa.com/";
    openLink(url);
  };

  const openLink = (url) => {
    Linking.canOpenURL(url).then((supported) => {
      if (supported) {
        Linking.openURL(url);
      } else {
        console.log("Don't know how to open URI: " + url);
      }
    });
  };

  const handleSubmit = async (userInfo) => {
    if (!terms) return StdAlert("", "Please, accept the terms.");
    const result = await registerApi.request(userInfo);

    // console.log(result, "oire");

    if (result.data.response.code !== "200") {
      console.log(result.data, "dsl");
      if (result.data) setError(result.data.response.message);
      else {
        setError("An unexpected error occurred.");
        // console.log(result);
      }
      return;
    } else {
      // alert('You have been successfully registered. Please, go back to Login.');
      StdAlert("Success", "You have been successfully registered.", () =>
        navigation.pop(1)
      );
      // Alert.alert(
      //   "Success",
      //   "You have been successfully registered.",
      //   [
      //     // {
      //     //   text: 'Cancel',
      //     //   onPress: () => console.log('Cancel Pressed'),
      //     //   style: 'cancel',
      //     // },
      //     { text: "Back to Login", onPress: () => navigation.pop(1) },
      //   ],
      //   { cancelable: false }
      // );
    }

    // const { data: login_detail } = await loginApi.request(
    //   userInfo.email,
    //   userInfo.password
    // );
    // auth.logIn(login_detail.access_token);
  };

  return (
    <Screen style={styles.container}>
      {/* <KeyboardAvoidingView
        behavior="position"
        keyboardVerticalOffset={keyboardVerticalOffset}
        style={{ flex: 1, flexDirection: "column", justifyContent: "center" }}
      > */}
      <ScrollView
        style={{ flex: 1, flexDirection: "column", marginBottom: 60 }}
        keyboardShouldPersistTaps="handled"
      >
        <ActivityIndicator visible={registerApi.loading || loginApi.loading} />

        <CommonHeader />

        <View style={{ padding: 10, alignItems: "center" }}>
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              justifyContent: "center",
              marginTop: 10,
              marginBottom: 10,
            }}
          >
            <AppText
              textColor="green"
              style={{ fontWeight: "500", fontSize: 22 }}
            >
              Check your{" "}
            </AppText>
            <AppText
              textColor="green"
              style={{ fontWeight: "bold", fontSize: 22 }}
            >
              SCORE{" "}
            </AppText>
            <AppText
              textColor="green"
              style={{ fontWeight: "500", fontSize: 22 }}
            >
              now{">"}
            </AppText>
          </View>
          <AppForm
            initialValues={{
              user_name: "",
              email: "",
              user_city: "",
              user_zip: "",
              user_country: "",
              password: "",
              confirmPassword: "",
            }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            <ErrorMessage error={error} visible={error} />
            <AppFormField
              style={{ marginVertical: 6 }}
              autoCapitalize="none"
              autoCorrect={false}
              icon="account-box"
              name="user_name"
              placeholder="Name"
            />
            <AppFormField
              style={{ marginVertical: 6 }}
              autoCapitalize="none"
              autoCorrect={false}
              icon="account-box"
              name="email"
              placeholder="Email"
            />
            {/* <View
              style={{
                flexDirection: "row",
                flex: 1,
              }}
            >
              <View style={{ flex: 1, marginRight: 5 }}>
                
              </View>
              <View style={{ flex: 1, marginLeft: 5 }}>
                
              </View>
            </View> */}
            {/* <Picker
                items={professions}
                name="country"
                icon="worker"
                numberOfColumns={3}
                PickerItemComponent={CategoryPickerItem}
                placeholder="Country"
              /> */}
            <AppFormField
              style={{ marginVertical: 6 }}
              autoCapitalize="none"
              autoCorrect={false}
              icon="briefcase"
              name="user_city"
              placeholder="City"
            />
            <AppFormField
              style={{ marginVertical: 6 }}
              autoCapitalize="none"
              autoCorrect={false}
              icon="contact-phone"
              name="user_zip"
              placeholder="Zip"
              // textContentType="telephoneNumber"
              // keyboardType={Platform.OS === "ios" ? "number-pad" : "phone-pad"}
            />
            <AppFormField
              style={{ marginVertical: 6 }}
              autoCapitalize="none"
              autoCorrect={false}
              icon="city"
              name="user_country"
              placeholder="Country"
            />
            <AppFormField
              style={{ marginVertical: 6 }}
              autoCapitalize="none"
              autoCorrect={false}
              icon="lock"
              name="password"
              placeholder="Password"
              secureTextEntry
              textContentType="password"
            />
            <AppFormField
              style={{ marginVertical: 6 }}
              autoCapitalize="none"
              autoCorrect={false}
              icon="lock"
              name="confirmPassword"
              placeholder="Confirm Password"
              secureTextEntry
              textContentType="password"
            />
            <View
              style={{
                flex: 1,
                justifyContent: "center",
                // alignContent: "center",
                alignItems: "center",
                marginBottom: 20,
              }}
            >
              <TouchableOpacity
                style={{
                  // flex: 1,
                  flexDirection: "row",
                  // marginTop: 20,
                  alignItems: "center",
                }}
                onPress={() => setTerms(!terms)}
              >
                <View
                  style={{
                    borderRadius: 2,
                    borderWidth: 1,
                    borderColor: colors.gray,
                    marginHorizontal: 20,
                    flex: 0.1,
                    height: 30,
                    alignItems: "center",
                  }}
                >
                  <Text
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "center",
                      color: colors.gray,
                      fontSize: 20,
                    }}
                  >
                    {terms ? "✓" : " "}
                  </Text>
                </View>
                <AppText
                  style={{ marginTop: 20, textAlign: "left", flex: 0.9 }}
                  color="transparent"
                >
                  I have read and agreed to the{" "}
                  <Text onPress={privacyAction} style={styles.boldText}>
                    Privacy Policy
                  </Text>{" "}
                  and{" "}
                  <Text onPress={termsAction} style={styles.boldText}>
                    Terms of Use
                  </Text>{" "}
                  of{" "}
                  <Text onPress={websiteAction} style={styles.boldText}>
                    BlueCardVisa.com
                  </Text>
                </AppText>
              </TouchableOpacity>
            </View>
            <SubmitButton title="Signup" />
          </AppForm>
        </View>
      </ScrollView>
      <View style={{ position: "absolute", bottom: 0 }}>
        <CommonFooter navigation={navigation} />
      </View>
      {/* </KeyboardAvoidingView> */}
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // padding: 10,
  },
  logo: {
    width: 80,
    height: 80,
    backgroundColor: colors.primaryTrans,
    alignSelf: "center",
    marginTop: 50,
    marginBottom: 20,
    borderRadius: 20,
  },
  boldText: {
    color: "#696969",
    fontWeight: "bold",
    textDecorationLine: "underline",
  },
});

export default SignupScreen;
